enum ModalToOpen {
	DuplicateCatalogDialog = "DuplicateCatalogDialog",
	DuplicateArticleDialog = "DuplicateArticleDialog",
	MergeConfirm = "MergeConfirm",
	MergeResolver = "MergeResolver",

	CheckoutHandler = "CheckoutHander",
	CloneHandler = "CloneHandler",
	Clone = "Clone",
	PullHandler = "PullHandler",

	ImportModal = "ImportModal",

	FragmentAlreadyUseWarn = "FragmentAlreadyUseWarn",

	Loading = "Loading",

	MultilangActionConfirm = "MultilangActionConfirm",

	DiagramEditor = "DiagramEditor",
	HTMLEditor = "HTMLEditor",

	Merge = "Merge",
	CreateMergeRequest = "CreateMergeRequest",
	MergeRequestConfirm = "MergeRequestConfirm",
	CreateStorage = "CreateStorage",

	EnterpriseLogout = "EnterpriseLogout",
	RepositoryPermission = "RepositoryPermission",

	TemplateContentWarning = "TemplateContentWarning",
	PropertySettings = "PropertySettings",

	CloudModal = "CloudModal",

	CreateWorkspaceForm = "CreateWorkspaceForm",

	MediaPreview = "MediaPreview",
	FilePreview = "FilePreview",

	// Article dropdown modals
	ItemPropsEditor = "ItemPropsEditor",
	MarkdownEditor = "MarkdownEditor",
	BugsnagModal = "BugsnagModal",
	UnsupportedElements = "UnsupportedElements",
	Share = "Share",
	NotificationSettings = "NotificationSettings",

	// Catalog dropdown modals
	Healthcheck = "Healthcheck",

	ActionConfirm = "ActionConfirm",

	ExportPdf = "ExportPdf",

	GesAdmin = "GesAdmin",

	DefaultModal = "DefaultModal",
	UnsavedChangesModal = "UnsavedChangesModal",

	TauriGesSignIn = "TauriGesSignIn",

	CreateAccessToken = "CreateAccessToken",
	ShowAccessToken = "ShowAccessToken",

	GesCloudInitCatalog = "GesCloudInitCatalog",
	GesCloudSignIn = "GesCloudSignIn",
	GesCloudInviteMember = "GesCloudInviteMember",
	TariffChoose = "TariffChoose",
	GesCloudPurchaseSeatPayModal = "GesCloudPurchaseSeatPayModal",
	GesCloudPayerTypeChoose = "GesCloudPayerTypeChoose",
	GesCloudChangePeriod = "GesCloudChangePeriod",
	GesCloudLegalEntitySwitch = "GesCloudLegalEntitySwitch",
	GesCloudInviteMismatch = "GesCloudInviteMismatch",
	GesCloudOrganizationSettings = "GesCloudOrganizationSettings",
	GesCloudSignOut = "GesCloudSignOut",
	GesAppSettings = "GesAppSettings",
	GesCloudRecoverPaymentInfo = "GesCloudRecoverPaymentInfo",
	CancelSubscription = "CancelSubscription",

	AlertConfirm = "AlertConfirm",
	LfsMigration = "LfsMigration",
	LfsAutoAttachments = "LfsAutoAttachments",

	AppSettings = "AppSettings",
	AgentContextUsageModal = "AgentContextUsageModal",
}

export default ModalToOpen;
